module.exports = __webpack_public_path__ + "img/China-5.9c12869a.jpg";